import { useEffect } from 'react'
import { ErrorLogger } from '@npco/utils-error-logger'
import { updateSardineConfig } from '@sardine-ai/web-sdk'

import { SESSION_STORAGE_KEYS } from 'services/sessionStorage/keys'
import { getSessionStorageItem } from 'services/sessionStorage/utils'

export const useUpdateSardineConfig = () => {
  const zellerSessionId = getSessionStorageItem(
    SESSION_STORAGE_KEYS.ZELLER_SESSION_ID
  )
  useEffect(() => {
    if (typeof zellerSessionId === 'string') {
      updateSardineConfig({
        sessionKey: zellerSessionId,
        flow: 'signup',
      }).catch((err) => {
        ErrorLogger.report('[Sardine - Signup] Fail to initialise', err)
      })
    }
  }, [zellerSessionId])
}
